import { render, staticRenderFns } from "./STEmojiPicker.vue?vue&type=template&id=2e851b32&scoped=true"
import script from "./STEmojiPicker.vue?vue&type=script&lang=js"
export * from "./STEmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./STEmojiPicker.vue?vue&type=style&index=0&id=2e851b32&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e851b32",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
